import { createApp } from 'vue'
import { createPinia } from 'pinia'
import VueKonva from 'vue-konva'
import App from './App.vue'

const app = createApp(App)
app.use(createPinia())
app.use(VueKonva)
app.mount('#deco-app')

// フォントは先読みしない (起動時に巨大な日本語フォントを全DLして遅くなるため)。
// 各フォントは必要になった時点で読み込む:
//   - キャンバスのテキスト: DrawableText.vue の measureText() が描画時にオンデマンド読み込み + 再描画
//   - フォントピッカーのプレビュー: FontSelector.vue が画面内に入った項目のみ読み込み
